export default (props, e) => {
  e.preventDefault();
  window.print();
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/printPage.js